import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from './api';
import AuthShell from './shared/AuthShell';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { FORGOT_PASSWORD } from '../constants/testIds';
import { Loader2, ArrowRight } from 'lucide-react';

// Ticket 140: always shows the same success copy whether or not the email
// has an account — the backend never leaks account existence either.
export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/auth/password/forgot', { email });
    } catch (e) {
      // Ignore — the endpoint always 200s; a network/5xx failure still gets
      // the same reassuring copy rather than a dead-end error state.
    } finally {
      setBusy(false);
      setSent(true);
    }
  };

  if (sent) {
    return (
      <AuthShell tagline="Password reset" testId="forgot-password-page">
        <h2 className="font-serif text-3xl font-semibold text-brand-navy">Check your email</h2>
        <p className="text-slate-500 mt-2">
          If that email has an account, a reset link is on its way. Check spam too.
        </p>
        <Button variant="accent" className="mt-6 justify-center" onClick={() => navigate('/portal/login')} data-testid={FORGOT_PASSWORD.loginLink}>
          Back to sign in <ArrowRight size={14} />
        </Button>
      </AuthShell>
    );
  }

  return (
    <AuthShell tagline="Password reset" testId="forgot-password-page">
      <h2 className="font-serif text-3xl font-semibold text-brand-navy">Forgot your password?</h2>
      <p className="text-slate-500 mt-2">Enter your email and we'll send you a reset link.</p>
      <form onSubmit={submit} className="space-y-4 mt-8">
        <div>
          <Label>Email</Label>
          <Input
            type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            required className="mt-1.5" placeholder="you@company.com" data-testid={FORGOT_PASSWORD.emailInput}
          />
        </div>
        <Button type="submit" disabled={busy} variant="accent" className="w-full justify-center" data-testid={FORGOT_PASSWORD.submitButton}>
          {busy ? <><Loader2 size={16} className="animate-spin" /> Sending...</> : <>Send reset link <ArrowRight size={14} /></>}
        </Button>
      </form>
      <p className="text-sm text-slate-500 mt-6 text-center">
        <button type="button" className="font-semibold hover:underline" style={{ color: '#6BA82E' }} onClick={() => navigate('/portal/login')}>
          Back to sign in
        </button>
      </p>
    </AuthShell>
  );
}
